import '../../Components/Page/Page.css'
import SecHeader from '../../Components/SecHeader/SecHeader';
import '../Software/Software.css';


const Competition: React.FC = () => {
    return (
        <div className='software'>
            <SecHeader title="Competition" />
            <div className="description">
                <p>
                    <div>
                        <b>Continuing to Use Current, Less Capable Engines​</b>
                        <br />When our tech become known, less capable engines will become less desirable. The
                        current slowness to change will disappear as the world sees our R&D and test data, our
                        POC engines, our academic papers, and the ELF-Tech patents.
                        <br />
                    </div>
                    <div>
                        <b>Other “Want-to-Be-the-Next Best Engine(s)”​</b>
                        <br />Other new engine designs that tout benefits include: Liquid-Piston, Omega1, Achates,
                        VC-Tech, D-Cycle, split-cycle designs, InnEngine, Alfadan, SyTech, Mazda’s new 2-
                        stroke, Toyota’s 2-stroke, Renault’s 2-stroke, DeltaHawk’s 2-stroke, Porsche’s 6-stroke,
                        CV-Motion, and others. Our E-SPEC identifies and analyzes all limitations of “want-to-
                        be-the-next engines” and defines them in our global engine designs databases.
                        <br />
                    </div>
                    <div>
                        <b>EVs are “False Competition”​</b>
                        <br />It is only wishful to think that we can replace all engines with electric motors. Even if we
                        could, all-electric power for work may not help the Earth as much as some think. The
                        best EVs will have range extenders. Hybrids are more versatile (and greener) and finally,
                        new engines and fuels can and will be cleaner (and better for CO2 levels) than 100%
                        electric power for work.
                        <br />
                    </div>
                </p>
            </div>
        </div>
    );
};

export default Competition;